export default "__VITE_ASSET__67ef83c5__"